import failAction from './failAction'
import requestAction from './requestAction'
import successAction from './successAction'
import loader from './loader'

export default {
  createFetchFoldersRequestAction: requestAction,
  createFetchFoldersSuccessAction: successAction,
  createFetchFoldersFailAction: failAction,
  createFetchFoldersLoader: loader,
}
